import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { ViewRemediationPage } from '@/features/view-remediation/ViewRemediationPage';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';

const viewRemediationSearchSchema = z.object({
  tab: z.enum(['assigned-to-me', 'all', 'pending-review']).optional().catch(undefined),
});

export const Route = createFileRoute('/_protected/t/$tenantId/view-remediation/')({
  component: ViewRemediationLandingRoute,
  validateSearch: viewRemediationSearchSchema,
});

function ViewRemediationLandingRoute() {
  const { tab } = Route.useSearch();
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <ViewRemediationPage initialViewsTab={tab} />
    </ErrorBoundary>
  );
}
